var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 12C19 10.2149 18.318 8.49727 17.0935 7.19836C15.8691 5.89944 14.1946 5.1174 12.4126 5.01217C10.6307 4.90695 8.8758 5.48649 7.50696 6.63226C6.13812 7.77804 5.25873 9.40349 5.04865 11.1762C4.83856 12.9488 5.31365 14.7348 6.37674 16.1688C7.43984 17.6028 9.01062 18.5765 10.7678 18.8907C12.525 19.2049 14.3359 18.8359 15.8301 17.8592C17.3243 16.8825 18.3888 15.3718 18.8061 13.6362L16.3047 13.0349C16.0408 14.1326 15.3675 15.0881 14.4225 15.7058C13.4774 16.3236 12.3321 16.557 11.2207 16.3582C10.1093 16.1595 9.11579 15.5437 8.4434 14.6367C7.77101 13.7297 7.47053 12.6001 7.60341 11.4789C7.73628 10.3578 8.29248 9.3297 9.15824 8.60501C10.024 7.88033 11.1339 7.51378 12.261 7.58034C13.3881 7.64689 14.4471 8.14152 15.2216 8.96306C15.996 9.78459 16.4274 10.871 16.4274 12H19Z",
    fill: "#8E97A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.d398c0febacae769aaca9992c6987899.svg";
export { ForwardRef as ReactComponent };